import BaseView from "./_BaseView";
import Table from "../components/Table";
import Confirm from "../components/Confirm";
import Api from "../Api";

export default class SegmentView extends BaseView {
    constructor() {
        super();
        this.tables = [];
    }

    init() {
        super.init();
        const self = this;

        if ($('#segments').length > 0) {
            $('.segmentTable').each(function () {
                const id = $(this).attr('id');
                const appType = $(this).data('app-type');
                self.tables.push(
                    new Table(id, `/api/segments/table?app_type_id=${appType}`, [
                        {data: 'title', orderable: true},
                        {data: 'description'},
                        {data: 'guides', orderable: false},
                        {data: 'tools', orderable: false},
                    ])
                );
            });
        }
    }

    setEvents() {
        super.setEvents();
        const self = this;

        $('#segments').on('click', '.delete', function () {
            if ($(this).hasClass('disabled')) {
                return false;
            }
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(1)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: `<strong>${Lang.segmentdel}</strong><br>${Lang.delsure}`,
                onConfirm: function () {
                    Api.send(`/api/segments/${id}`, {}, 'delete').done(function () {
                        self.tables.forEach(function (table) {
                            table.reload();
                        });
                    });
                }
            });
            return false;
        });
    }
}